<template>
  <div class='sub-content' > <!-- 여기까지 page header 이하 수정해서 사용-->
    <div class='bom-main float-left'>
      <dx-data-grid ref='refBomMainGrid'
        :data-source='carTypeLookup'
        :show-borders = 'true' :showRowLines = 'false' :showColumnLines='true'
        :hover-state-enabled = "true" :allowColumnResizing = 'true'
        column-resizing-mode = 'widget' :allow-column-reordering = "true"
        :height='gridHeight' :row-alternation-enabled="true"
        :focused-row-enabled="true"
        @focused-row-changed="onSelectionChanged"
        :auto-navigate-to-focused-row="false"
        key-expr="모델코드"
        :focused-row-key.sync='focusedRowKey'
        @toolbar-preparing='onToolbarPreparing'
      >
        <DxSearchPanel
          :visible="true"
          placeholder="검색..."
        />
        <DxExport
          :enabled="true"
          file-name="차종리스트"
        />
        <DxFilterRow
          :visible="true"
          apply-filter="auto"
        />
        <DxColumnFixing :enabled="true"/>
         <DxColumn
            :allowEditing='true'
            :fixed="true"
            caption="차종코드"
            data-field="모델코드"
          >
          </DxColumn>
          <DxColumn
            :allowEditing='true'
            caption="차종명"
            data-field="모델명"
            :visible='true'
          >
          </DxColumn>
          <DxColumn
            :allowEditing='true'
            caption="양산차종"
            data-field="사용유무"
            :visible='true'
            sort-order="desc"
          >
          </DxColumn>
          <DxColumn
            :allowEditing='true'
            caption="삭제유무"
            data-field="삭제유무"
            :visible='true'
          >
          </DxColumn>
          <DxSummary>
            <DxTotalItem
              value-format='#,##0'
              show-in-column="모델코드"
              display-format="{0} (건)"
            />
          </DxSummary>
          <dx-paging :enabled="false"/>
          <dx-scrolling mode="virtual" showScrollbar='always' :useNative='false'/>
          <dx-sorting mode="multiple"/>
      </dx-data-grid>
    </div>
    <!-- *************************************** SUB ***************************-->
    <div class='bom-sub bom-sub-car float-left'>
      <dx-tree-list ref='refBomSubGrid'
        :data-source='bomInfoList'
        :height='gridHeight'
        :autoExpandAll='true'
        :show-borders="true" :showRowLines = 'true'
        :column-auto-width="true"
        :hover-state-enabled = "true"
        key-expr="selfKey"
        parent-id-expr="상위품번"
        :selection="{ mode: 'single' }"
        :focused-row-enabled="true"
        :allow-column-resizing="true"
        column-resizing-mode="nextColumn"
        @focused-row-changed="onSelectionSubChanged"
        :auto-navigate-to-focused-row="false"
        @toolbar-preparing='onToolbarPreparingSub'
        @init-new-row='onInitNewRowBom'
        @row-inserting="onRowInsertingBom"
        @row-inserted="onRowInsertedBom"
        @row-removed='onRowRemovedBom'
        @row-removing='onRowRemovingBom'
        @row-updating='onRowUpdatingBom'
        @row-updated='onRowUpdatedBom'
        @editor-preparing='onEditorBomPreparing'
        @cell-prepared='onCellPreparedBom'
      >
        <DxSearchPanel
          :visible="true"
          placeholder="검색..."
        />
        <DxEditing v-if="editable"
          :allow-deleting="isDelete"
          :allow-updating="isDelete"
          :allow-adding="editable"
          :use-icons="true"
          mode='batch'
        >
        </DxEditing>
        <DxColumn
          :allowEditing='isEdit'
          caption="품번/차종사양"
          data-field="품번"
          :visible='true'
          sort-order="asc"
        >
        </DxColumn>
        <DxColumn
          :allowEditing='true'
          caption="품명/사양명"
          data-field="품명"
        >
        </DxColumn>
        <DxColumn
          :allowEditing='true'
          caption="점유율"
          data-field="생산점유율"
          format='#0.##%'
          dataType="number"
        >
        </DxColumn>
        <DxColumn
          :allowEditing='true'
          caption="원수"
          data-field="수량"
          dataType="number"
          format='#,##0.0'
        >
        </DxColumn>
        <DxColumn
          :allowEditing='false'
          caption="단위"
          data-field="단위"
          :visible='false'
        >
          <DxLookup
            :data-source="unitLookup"
            display-expr="코드명"
            value-expr="코드"
          />
        </DxColumn>
        <DxColumn
          :allowEditing='false'
          caption="품목유형"
          data-field="품목유형"
          :visible='true'
        >
          <DxLookup
            :data-source="goodsLookup"
            display-expr="코드명"
            value-expr="코드"
          />
        </DxColumn>
        <DxColumn
          :allowEditing='false'
          caption="자재유형"
          data-field="자재유형"
          :visible='true'
        >
          <DxLookup
            :data-source="materialTypeLookup"
            display-expr="코드명"
            value-expr="코드"
          />
        </DxColumn>
        <DxColumn
          :allowEditing='isEditCustomer'
          caption="발주사"
          data-field="발주사"
          :visible='true'
          sort-order="asc"
        >
           <DxLookup
            :data-source="customerLookup"
            display-expr="거래처명"
            value-expr="거래처코드"
          />
        </DxColumn>
        <DxColumn
          :allowEditing='false'
          caption="기준일"
          data-field="기준일"
          dataType= 'date'
          format='yyyy-MM-dd'
          width = '100'>
        </DxColumn>
        <DxColumn
          :allowEditing='true'
          caption="사용유무"
          data-field="사용유무"
          :visible='true'
            >
        </DxColumn>
        <DxColumn
          :allowEditing='false'
          :visible="false"
          caption="등록일"
          data-field="createtime"
          dataType= 'date'
          format='yyyy-MM-dd HH:mm:ss'>
        </DxColumn>
        <DxSummary>
          <DxTotalItem
            value-format='#,##0'
            show-in-column="품번"
            display-format="{0} (건)"
          />
        </DxSummary>
        <dx-paging :enabled="false"/>
        <dx-scrolling mode="virtual" showScrollbar='always' :useNative='false'/>
         <dx-sorting mode="none"/>
        <template #bom-sub>
          <div class="toolbar-label" style='font-size:1.2rem;margin-left:0px;'>
            <b v-if='selectedRow'>BOM(차종: {{selectedRow.모델코드}})</b>
          </div>
      </template>
      </dx-tree-list>
    </div>
     <!-- *************************************** productInfoListByType ***************************-->
    <div class='product-list float-left' style='overflow:hidden;display:block; width:0%; margin-left:10px;'>
      <dx-data-grid ref='productGrid'
        :data-source='productInfoListByType'
        :show-borders = 'true' :showRowLines = 'false' :showColumnLines='true'
        :hover-state-enabled = "true" :allowColumnResizing = 'true'
        column-resizing-mode = 'widget' :allow-column-reordering = "true"
        :height='gridHeight' :row-alternation-enabled="true"
        :focused-row-enabled="true"
        :auto-navigate-to-focused-row="false"
        :selected-row-keys.sync="selectedRowKeys"
        key-expr="품번"
        @toolbar-preparing='onToolbarPreparingProduct'
      >
        <DxSearchPanel
          :visible="true"
          placeholder="검색..."
        />
        <DxSelection mode="multiple"
          show-check-boxes-mode="always"
        />
        <DxExport
          :enabled="true"
          :file-name="bomReportFile"
        />
        <DxFilterRow
          :visible="true"
          apply-filter="auto"
        />
        <DxColumnFixing :enabled="true"/>
        <DxColumn v-if="$store.getters.getGroupName !== null"
          :allowEditing='true'
          :caption="$store.getters.getGroupName"
          data-field="차종"
          sort-order="asc"
          :visible='true'
        >
           <DxLookup
            :data-source="carTypeLookup"
            display-expr="모델명"
            value-expr="모델코드"
          />
          <dx-required-rule message="항목을 선택하세요"/>
        </DxColumn>
        <DxColumn
          :allowEditing='false'
          caption="품번"
          data-field="품번"
          :visible='true'
          sort-order="asc"
        >
        </DxColumn>
        <DxColumn
          :allowEditing='false'
          caption="품명"
          data-field="품명"
        >
        </DxColumn>
        <DxColumn
          :allowEditing='true'
          caption="품목유형"
          data-field="품목유형"
          :visible='true'
        >
          <DxLookup
            :data-source="goodsLookup"
            display-expr="코드명"
            value-expr="코드"
          />
        </DxColumn>
        <DxColumn
          :allowEditing='true'
          caption="공정유형"
          data-field="공정유형"
          :visible='true'
        >
          <DxLookup
            :data-source="itemTypeLookup"
            display-expr="코드명"
            value-expr="코드"
          />
        </DxColumn>
        <DxColumn
          :allowEditing='false'
          caption="자재유형"
          data-field="자재유형"
          :visible='true'
        >
          <DxLookup
            :data-source="materialTypeLookup"
            display-expr="코드명"
            value-expr="코드"
          />
        </DxColumn>
        <DxSummary>
          <DxTotalItem
            value-format='#,##0'
            show-in-column="품번"
            display-format="{0} (건)"
          />
        </DxSummary>
        <dx-paging :enabled="false"/>
        <dx-scrolling mode="virtual" showScrollbar='always' :useNative='false'/>
        <dx-sorting mode="multiple"/>
      </dx-data-grid>
    </div>
    <input id="batch-detail-input" type="file" @change="onDetailFileChange($event)" accept=".xlsx" style='display: none;'>
    <loading :active.sync="isLoading" color='rgb(2, 110, 156)' loader='bars'></loading>
  </div> <!--sub-conten end-->
</template>

<script>
import Loading from 'vue-loading-overlay'
import ConstDef from '../../share/ConstDef'
import AppLib from '../../share/AppLib'
import DxDataGrid, { DxScrolling, DxFilterRow, DxExport, DxColumnFixing, DxTotalItem,
  DxSummary, DxColumn, DxPaging, DxSorting, DxEditing, DxSearchPanel, DxSelection,
  DxLookup } from 'devextreme-vue/data-grid'
import { DxRequiredRule } from 'devextreme-vue/validator'
import { DxTreeList } from 'devextreme-vue/tree-list'
import axios from 'axios'
import ExcelJS from 'exceljs'

export default {
  name: 'login',
  data: function () {
    return {
      isLoading: false,
      // 제품리스트
      carTypeLookup: null,
      gridHeight: null,
      selectedRow: null,
      focusedRowKey: null,
      // BOM
      bomInfoList: null,
      bomReportFile: 'bomCar',
      goodsLookup: null,
      itemTypeLookup: null,
      materialTypeLookup: null,
      selectedRowBom: null,
      isEdit: true,
      currentBomDataSource: null,
      customerLookup: null,
      isEditCustomer: true,
      baseDate: null,
      // product
      productInfoListByType: null,
      selectedPrductType: ConstDef.완제품,
      productypeLookup: null,
      selectedRowKeys: []
    }
  },
  props: {
    editable: {
      type: Boolean,
      default: true
    }
  },
  components: {
    Loading,
    DxDataGrid,
    DxExport,
    DxFilterRow,
    DxColumnFixing,
    DxTreeList,
    DxSelection,
    DxColumn,
    DxPaging,
    DxSorting,
    DxEditing,
    DxSearchPanel,
    DxLookup,
    DxSummary,
    DxTotalItem,
    DxScrolling,
    DxRequiredRule
  },
  created () {
    document.title = ConstDef.WEB_TAB_TITLE
    this.userInfo = this.$store.getters.getUserInfo
    if (this.userInfo === null) {
      this.$router.push('/')
    }
    this.baseDate = `${AppLib.getToday().substring(0, 7)}-01`
    this.itemTypeLookup = this.$store.getters.getBaseDataByType(ConstDef.공정유형)
    this.materialTypeLookup = this.$store.getters.getBaseDataByType(ConstDef.자재유형)
    this.goodsLookup = this.productypeLookup = this.$store.getters.getBaseDataByType(ConstDef.품목유형)
    this.unitLookup = this.$store.getters.getBaseDataByType(ConstDef.단위)
    this.customerLookup = this.$store.getters.getFirstVendor
    this.refreshCarType()
    this.refreshProductListByType(this.selectedPrductType)
  },
  mounted () {
    this.gridHeight = (screen.height - 250) * 0.95
  },
  updated () {
  },
  beforeDestroy: function () {
  },
  methods: {
    // ****************** 제품 Grid ************************************
    onSelectionChanged (e) {
      if (e != null && e.row === undefined) {
        return
      }
      if (e !== null) {
        this.selectedRow = e.row.data
      }
      this.bomReportFile = `BOM_차종_${this.selectedRow.모델코드}`
      this.refreshBomList(this.selectedRow.모델코드)
    },
    onToolbarPreparing (e) {
      e.toolbarOptions.items.unshift(
        {
          location: 'before',
          template: function () {
            return `<div class="toolbar-label" style='margin-left:4px;'><b>차종별 완제품 BOM</b></div>`
          }
        }
      )
    },
    refreshCarType () {
      this.$_sp.runNoEncodeFindSqlProc('고객사생산품목', null)
        .then((data) => {
          this.carTypeLookup = this.$_.sortBy(this.$_sp.MakeModel(data), '모델명')
        })
    },
    // ****************** BOM Grid ************************************
    addBomList () {
      this.$Q('.bom-main').css('width', '20%')
      this.$Q('.bom-sub').css('width', '39%')
      this.$Q('.product-list').css('width', '38%')
    },
    isDelete (e) {
      if (e === undefined) return false
      if (!this.editable) return false
      if (e.row.data.상위품번 === null) {
        return false
      }
      return true
    },
    isDeleteBtn (e) {
      return e.row.level !== 1
    },
    isAddBtn (e) {
      return e.row.level === 0
    },
    isUpdateBtn (e) {
      return e.row.level === 1
    },
    onCellPreparedBom (e) {
      if (e.rowType === 'data') {
        if (e.column.dataField === '품번' && e.data.createtime + 1000 * 10 > AppLib.nowTimestamp()) {
          this.$Q(e.cellElement).css('color', 'red')
        } else if (e.column.dataField === '발주사' && e.data.상위품번 !== null && this.selectedRow.모델코드 === e.data.최상위품번 && this.selectedRow.모델코드 !== e.data.상위품번) {
          const where = this.$_.where(this.bomInfoList, { 상위품번: e.data.상위품번 })
          // where.forEach(item => {
          //   console.log(item.발주사)
          // })
          // console.log(e.data.발주사)
          if (where.length > 0) {
            const count = this.$_.where(where, { 품번: e.data.품번, 발주사: e.data.발주사 }).length
            if (count > 1) {
              this.$Q(e.cellElement).css('color', 'white')
              this.$Q(e.cellElement).css('background-color', 'red')
            }
          }
        }
      }
    },
    onEditorBomPreparing (e) {
      if (e.dataField === '품명' && e.row !== undefined) {
        console.log(e)
        if (e.row.isNewRow === true) {
          this.isEdit = true
        } else {
          this.isEdit = false
        }
      }
    },
    onInitNewRowBom (row) {
      if (row.data.상위품번 !== this.selectedRow.모델코드) {
        this.$snotify.info('차종 사양 및 품목의 하위 노드는 추가할 수 없습니다.')
        setTimeout(() => {
          row.component.cancelEditData()
        }, 0)
      } else {
        this.isEdit = true
      }
    },
    onRowInsertingBom (row) {
      if (row.data.상위품번 === this.selectedRow.모델코드) {
        if (row.data.생산점유율 === null) {
          this.$snotify.info('차종별 사양 생산점유율을 입력 하여주세요.')
          row.cancel = true
        }
      }
    },
    onRowInsertedBom (row) {
      console.log(row.data)
      row.data.최상위품번 = this.selectedRow.모델코드
      row.data.selfKey = `${row.data.품번}${row.data.상위품번}`
      row.data.createtime = row.data.updatetime = AppLib.nowTimestamp
      row.data.createid = row.data.updateid = this.userInfo.userName
      row.data.기준일 = this.baseDate
      this.$_sp.runInsertSqlProc('BOM차종', null, [row.data])
        .then((data) => {
          this.isEdit = false
          this.refreshBomList(this.selectedRow.모델코드)
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    },
    onRowRemovedBom (row) {
      const childArray = this.$_.findWhere(this.currentBomDataSource, { key: row.data.selfKey }).children
      let param = [
        {
          seqId: row.data.seqId
        }
      ]
      for (let i = 0; i < childArray.length; i++) {
        param.push({ seqId: childArray[i].data.seqId })
      }
      this.$_sp.runDeleteSqlProc('BOM차종', param)
        .then((data) => {
          this.refreshBomList(this.selectedRow.모델코드)
          this.selectedRowBom = null
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    },
    onRowRemovingBom (row) {
      this.currentBomDataSource = this.$refs.refBomSubGrid.instance.getDataSource()._items
    },
    onRowUpdatingBom (row) {
      if (row.oldData.상위품번 === this.selectedRow.모델코드) {
        if (row.newData.생산점유율 !== undefined && row.newData.생산점유율 === null) {
          this.$snotify.info('차종별 사양 생산점유율을 입력 하여주세요.')
          row.cancel = true
        } else if (row.newData.생산점유율 === undefined && row.oldData.생산점유율 === null) {
          this.$snotify.info('차종별 사양 생산점유율을 입력 하여주세요.')
          row.cancel = true
        }
      }
    },
    onRowUpdatedBom (row) {
      row.updateId = this.userInfo.userId
      row.updatetime = AppLib.getNow()
      this.$_sp.runUpdateSqlProc('BOM차종', ['seqId'], ['품번', '최상위품번', '품목유형', '자재유형', '공정유형', '단위'], [row.data])
        .then((data) => {
          // this.$snotif.info('저장 되었습니다.')
          // this.$_sp.deleteForwardBom(this.selectedRow.품번)
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    },
    onToolbarPreparingSub (e) {
      e.toolbarOptions.items.unshift(
        {
          location: 'before',
          template: 'bom-sub'
        },
        {
          location: 'after',
          template: function () {
            return `<div class="toolbar-label" style='margin-left:4px;'><b>기준일:</b></div>`
          }
        },
        {
          location: 'after',
          widget: 'dxDateBox',
          options: {
            width: 94,
            value: this.baseDate,
            type: 'date',
            displayFormat: 'yyyy-MM-dd',
            onValueChanged: (args) => {
              console.log(`${args.value.substring(0, 7)}-01`)
              this.baseDate = `${args.value.substring(0, 7)}-01`
            }
          }
        },
        {
          location: 'after',
          widget: 'dxButton',
          options: {
            hint: '추가',
            icon: 'add',
            text: '품목추가',
            type: 'default',
            focusStateEnabled: true,
            onClick: (args) => {
              if (this.selectedRowBom === null || this.selectedRowBom.품번 === this.selectedRow.모델코드) {
                this.$snotify.error('추가하고자 하는 차종 사양을 먼저 선택하여 주세요')
              } else {
                this.$snotify.info(`${this.selectedRowBom.품번} 사양 하위에 품목을 추가 합니다.`)
                this.addBomList()
              }
            }
          }
        },
        {
          location: 'after',
          widget: 'dxButton',
          options: {
            disabled: true,
            hint: '엑셀파일등록',
            icon: 'add',
            text: '품목 파일일괄등록',
            type: 'success',
            focusStateEnabled: true,
            onClick: (args) => {
              this.$Q('#batch-detail-input').click()
            }
          }
        }
      )
    },
    async onDetailFileChange ($event) {
      const fileName = $event.target.files[0].name + ''
      if (fileName === '' || fileName === undefined || fileName === null) {
        return
      }
      console.log('************ onDetailFileChange=', fileName)
      let vm = this
      let file = document.getElementById('batch-detail-input')['files'][0]
      this.$Q('#batch-detail-input').val('')
      let reader = new FileReader()
      let craBomArray = null
      const del = this.$_sp.runUpdateProc('spDeleteTempCarProductMap', [{ null: '' }])
      const carBom = this.$_sp.runNoEncodeFindProc('spFindAllBomCarByOption', null)
      const del2 = this.$_sp.runUpdateProc('spDeleteProductionFromBomCar', [{ null: '' }])
      await axios.all([carBom, del, del2])
        .then(axios.spread((...reponse) => {
          craBomArray = this.$_sp.MakeModel(reponse[0])
          console.log(craBomArray)
        }))

      reader.onloadend = function (event) {
        let arrayBuffer = reader.result
        const workbook = new ExcelJS.Workbook()
        workbook.xlsx.load(arrayBuffer).then(function (workbook) {
          workbook.eachSheet(function (worksheet, sheetId) {
            if (worksheet.name !== '생산계획' && worksheet.name !== '사양표' && worksheet.name !== '대수' && worksheet.name !== '제품가격' && worksheet.name.indexOf('Sheet') < 0) {
              vm.saveCarMap(worksheet, craBomArray, worksheet.name)
            }
          })
        })
      }
      reader.readAsArrayBuffer(file)
    },
    async saveCarMap (worksheet, craBomArray, company) {
      this.isLoading = true
      let row = null
      let value = null
      let dataJson = {}
      for (let i = 8; i < 3000; i++) {
        row = worksheet.getRow(i)
        value = AppLib.getCellFromExcel(row, 2)
        if (value !== null && (value.indexOf('T O T A L') >= 0 || value.indexOf('TOTAL') >= 0)) continue
        if (value === null || value === '소급정산') {
          console.log(`${company}  read row=${i - 8}`)
          break
        }
        let option = AppLib.getCellFromExcel(row, 19)
        let splitOption = ['null']
        if (option !== null) {
          if (option !== 'A/S') {
            splitOption = AppLib.replaceAll(option, ',', '/')
            splitOption = splitOption.split('/')
          } else {
            continue
          }
        }
        for (let j = 0; j < splitOption.length; j++) {
          dataJson.발주사 = company
          dataJson.차종 = AppLib.getCellFromExcel(row, 2) // 62709-J5000
          dataJson.납입품번 = AppLib.getCellFromExcel(row, 3)
          dataJson.품번 = AppLib.getCellFromExcel(row, 4)
          dataJson.품명 = AppLib.getCellFromExcel(row, 5)
          dataJson.원단위 = AppLib.getCellFromExcel(row, 6)
          dataJson.사양 = splitOption[j].trim()
          let parentSelfKey = `${dataJson.사양}${dataJson.차종}`
          if (this.$_.findIndex(craBomArray, { 품번: dataJson.차종 }) < 0) {
            console.log('미등록 차종', dataJson.차종)
            dataJson.품명 = '미등록 차종'
            this.$_sp.runInsertSqlProc('TEMP_차종제품_맵', null, [dataJson])
          } else if (this.$_.findIndex(craBomArray, { selfKey: parentSelfKey }) < 0 || (dataJson.차종 === null || dataJson.품번 === null || dataJson.사양 === 'null')) {
            await this.$_sp.runInsertSqlProc('TEMP_차종제품_맵', null, [dataJson])
              .then((data) => {
              })
              // .catch(error => {
              //   if (error.response.status === ConstDef.GENERRAL_ERROR) {
              //     console.log(error.response.data.message)
              //   } else {
              //     console.log(`에러코드 : ${error.response.status}`)
              //   }
              // })
          } else {
            let temp = {
              selfKey: AppLib.uuidSequential(),
              품번: dataJson.품번,
              품명: dataJson.품명,
              수량: dataJson.원단위,
              발주사: this.$_.findWhere(this.customerLookup, { 거래처명: company }).거래처코드,
              상위품번: parentSelfKey,
              최상위품번: dataJson.차종,
              createid: this.userInfo.userName,
              updateid: this.userInfo.userName
            }
            console.log(temp)
            await this.$_sp.runNoEncodeFindSqlProc('품목정보', { 품번: dataJson.품번 })
              .then((data) => {
                const temp = this.$_sp.MakeModel(data)
                if (temp.length > 0) {
                  if (temp[0].품목유형 === ConstDef.완제품 ||
                      temp[0].품목유형 === ConstDef.반제품 ||
                      temp[0].품목유형 === ConstDef.다공정품 ||
                      temp[0].자재유형 === ConstDef.외주직납품) {
                    // this.$_sp.runInsertOrUpdayeSqlProc('BOM차종', ['selfKey'], null, [temp])
                    // this.$_sp.runUpdateSqlProc('품목정보', ['품번'], null, [{ 품번: dataJson.품번, 납입품번: dataJson.납입품번 }])
                  } else {
                    dataJson.품명 = `반제품(${temp[0].품목유형})`
                    this.$_sp.runInsertSqlProc('TEMP_차종제품_맵', null, [dataJson])
                  }
                } else {
                  dataJson.품명 = '미등록 품번'
                  this.$_sp.runInsertSqlProc('TEMP_차종제품_맵', null, [dataJson])
                }
              })
              // .catch(error => {
              //   if (error.response.status === ConstDef.GENERRAL_ERROR) {
              //     console.log(error.response.data.message)
              //   } else {
              //     console.log(`에러코드 : ${error.response.status}`)
              //   }
              // })
          }
        }
      }
      this.isLoading = false
    },
    onSelectionSubChanged (e) {
      if (e != null && e.row === undefined) {
        return
      }
      if (e !== null) {
        this.selectedRowBom = e.row.data
      }
    },
    refreshBomList (parentCode) {
      this.isLoading = true
      this.$_sp.runNoEncodeFindProc('spFindAllBomCarByParentCode', { 최상위품번: parentCode, 기준일: this.baseDate })
        .then((data) => {
          this.bomInfoList = this.$_sp.MakeModel(data)
          this.isLoading = false
          if (this.bomInfoList.length === 0) {
            // this.insertCarTypeTopParent()
          } else {
            let vue = this
            setTimeout(() => {
              vue.$refs.refBomSubGrid.instance.forEachNode(function (node) {
                vue.$refs.refBomSubGrid.instance.expandRow(node.key)
              })
            }, 100)
          }
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    },
    insertCarTypeTopParent () {
      let array = []
      const param = {
        selfKey: this.selectedRow.모델코드,
        품번: this.selectedRow.모델코드,
        품명: this.selectedRow.모델코드,
        최상위품번: this.selectedRow.모델코드,
        생산점유율: 1,
        기준일: this.baseDate
      }
      array.push(param)
      const option = {
        selfKey: `ALL${this.selectedRow.모델코드}`,
        품번: 'ALL',
        품명: 'ALL',
        상위품번: this.selectedRow.모델코드,
        최상위품번: this.selectedRow.모델코드,
        생산점유율: 1,
        기준일: this.baseDate
      }
      array.push(option)

      this.$_sp.runInsertSqlProc('BOM차종', null, array)
        .then((data) => {
          this.refreshBomList(this.selectedRow.모델코드)
        })
    },
    // **************** product list ********************************
    onToolbarPreparingProduct (e) {
      e.toolbarOptions.items.unshift(
        {
          location: 'before',
          widget: 'dxButton',
          options: {
            type: 'success',
            hint: '추가',
            icon: 'add',
            text: '선택품목 BOM 추가',
            focusStateEnabled: true,
            onClick: (args) => {
              if (this.selectedRowKeys.length === 0) {
                this.$snotify.info('선택된 완제품이 없습니다.')
                return
              } else if (this.selectedRowBom === null) {
                this.$snotify.error('추가하고자 하는 차종 사양을 먼저 선택하여 주세요')
                return
              }
              let saveList = []
              for (let i = 0; i < this.selectedRowKeys.length; i++) {
                console.log(this.selectedRowKeys)
                // if (this.$_.findIndex(this.bomInfoList, { 상위품번: this.selectedRowBom.품번, 품번: this.selectedRowKeys[i] }) >= 0) {
                //   continue
                // }
                let where = this.$_.findWhere(this.productInfoListByType, { 품번: this.selectedRowKeys[i] })
                let temp = {
                  selfKey: AppLib.uuidSequential(),
                  기준일: this.baseDate,
                  품번: where.품번,
                  품명: where.품명,
                  수량: 1,
                  발주사: where.납품처코드,
                  상위품번: this.selectedRowBom.selfKey,
                  최상위품번: this.selectedRow.모델코드,
                  사용유무: true,
                  삭제유무: false,
                  createid: this.userInfo.userName,
                  updateid: this.userInfo.userName
                }
                saveList.push(temp)
              }
              this.saveBomlist(saveList)
            }
          }
        },
        {
          location: 'before',
          widget: 'dxSelectBox',
          options: {
            width: 100,
            items: this.productypeLookup,
            valueExpr: '코드',
            displayExpr: '코드명',
            value: this.selectedPrductType,
            onValueChanged: (args) => {
              this.selectedPrductType = args.value
              this.refreshProductListByType(this.selectedPrductType)
            }
          }
        },
        {
          location: 'after',
          widget: 'dxButton',
          options: {
            icon: 'close',
            text: '닫기',
            focusStateEnabled: true,
            onClick: (args) => {
              this.$Q('.bom-main').css('width', '40%')
              this.$Q('.bom-sub').css('width', '58%')
              this.$Q('.product-list').css('width', '0%')
            }
          }
        }

      )
    },
    refreshProductListByType (type) {
      // this.$_sp.runNoEncodeFindProc('spFindAllProductByS0100OrS0409', null)
      this.$_sp.runNoEncodeFindSqlProc('품목정보', { 품목유형: type })
        .then((data) => {
          this.productInfoListByType = this.$_sp.MakeModel(data)
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    },
    async saveBomlist (list) {
      this.$refs.productGrid.instance.clearSelection()
      this.isLoading = true
      this.$_sp.runInsertSqlProc('BOM차종', null, list)
        .then((data) => {
          this.isLoading = false
          this.$snotify.info(`${list.length}행 등록 하였습니다. 필요시 수량/발주사 수정후 저장하여 주세요.`)
          this.refreshBomList(this.selectedRow.모델코드)
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    }

  }
}
</script>

<style lang="scss">
.sub-content{
  .bom-main{
    width:40%;
    margin-right:2%;
    border:0px solid red;
    min-height: 500px;
  }
  .bom-sub{
    width:58%;
    border:0px solid red;
    min-height: 500px;
  }
  .bom-sub-car .dx-treelist-addrow-button{
    display: none;
  }
}
</style>
